/**
 * ============================================================================
 *  APP · THEME MAPPING — which theme field drives which CSS custom property.
 * ============================================================================
 *
 *  The framework knows how to write CSS variables; it does not know that THIS site
 *  calls its brand colour `primary`. That mapping is an application decision and lives
 *  here, next to the stylesheet that consumes it.
 *
 *  Only the seven brand values are mapped. Every other colour in styles.css is mixed
 *  from these with color-mix, so it follows automatically — there is nothing to keep in
 *  step, which is the point.
 */
import type { CssVarMap } from '@framework/react';

export const THEME_VARS: CssVarMap = {
  primary: '--primary',
  secondary: '--secondary',
  cream: '--cream',
  mist: '--mist',
  sand: '--sand',
  coral: '--coral',
  olive: '--olive',
  fontDisplay: '--font-display',
  fontBody: '--font-body',
  radius: { cssVar: '--radius', unit: 'px' },
};
